module.exports = __webpack_public_path__ + "static/media/app.14c30482.png";